import { useEffect, useRef } from "react";
import { useAtomValue } from "jotai";
import { currentProjectIdAtom } from "../store/atoms/taskAtoms.js";
import { useMenu } from "./state/useMenu.js";

export const useFiltersMenuVisibility = () => {
  const currentProjectId = useAtomValue(currentProjectIdAtom);
  const { setFiltersMenuTemporaryVisible } = useMenu();
  const previousProjectIdRef = useRef(currentProjectId);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const previousProjectId = previousProjectIdRef.current;

    if (previousProjectId !== currentProjectId) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      setFiltersMenuTemporaryVisible(true);

      timeoutRef.current = setTimeout(() => {
        setFiltersMenuTemporaryVisible(false);
      }, 3000);

      previousProjectIdRef.current = currentProjectId;
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [currentProjectId, setFiltersMenuTemporaryVisible]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
};
